import { render, staticRenderFns } from "./RecentEvents.vue?vue&type=template&id=6660cae7&"
import script from "./RecentEvents.vue?vue&type=script&lang=js&"
export * from "./RecentEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports